import { render, staticRenderFns } from "./monitoringPhenologies.vue?vue&type=template&id=f1852772&"
import script from "./monitoringPhenologies.vue?vue&type=script&lang=js&"
export * from "./monitoringPhenologies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports